import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { merge } from 'rxjs';
import { withInitialValueDebounced } from '@shared/operators/with-initial-value-debounced.operator';
import { getControl } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { cloneDeep } from 'lodash-es';
import { addDays } from 'date-fns';
import { formPaths } from '@shared/constants/form-paths.const';
import { getAltreNotControl } from '../validators/helpers/altre-not-libri-soc-form.helper';

/** Replica VisualizzaControlloBloccoSemestrale (VBS OnLoad 1376-1391): mostra il warning se il
 * blocco semestrale (data_blocco_semestrale) + 210gg copre l'ultima revisione, o se manca ancora
 * una data ultima revisione pur essendoci un blocco semestrale. A differenza del VBS (calcolo
 * one-shot in OnLoad) qui è reattivo su entrambi i campi, coerente col modello a sessione lunga di NCR. */
export const setAltreNotLibriSocBloccoSemestraleListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    const dataBloccoSemestraleControl = getAltreNotControl(form, 'my_data_blocco_semestrale');
    const dataUltRevControl = getControl(form, `${formPaths.datiIdentificativi}.my_DataUltRev`);

    merge(dataBloccoSemestraleControl.valueChanges.pipe(withInitialValueDebounced(dataBloccoSemestraleControl)), dataUltRevControl.valueChanges.pipe(withInitialValueDebounced(dataUltRevControl)))
        .subscribe(() => {
            const dataBloccoSemestrale = dataBloccoSemestraleControl.value;
            const dataUltRev = dataUltRevControl.value;

            let visibile = false;
            if (!isNilOrEmpty(dataBloccoSemestrale)) {
                visibile = isNilOrEmpty(dataUltRev) || addDays(new Date(dataBloccoSemestrale), 210) >= new Date(dataUltRev);
            }

            const valore = visibile ? '1' : '0';

            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                myVerbaleClone.my_SezioneI__Rilevazione.my_AltreNotizie.my_VisualizzaControlloBloccoSemestrale = valore;
                return myVerbaleClone;
            });
        });
};
